module.exports = __webpack_public_path__ + "img/pr-20.52ac4318.png";